import { render, staticRenderFns } from "./FaultsEditMech.vue?vue&type=template&id=3f24177e&scoped=true&"
import script from "./FaultsEditMech.vue?vue&type=script&lang=js&"
export * from "./FaultsEditMech.vue?vue&type=script&lang=js&"
import style0 from "./FaultsEditMech.vue?vue&type=style&index=0&id=3f24177e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24177e",
  null
  
)

export default component.exports